const Footer = () => {
    return(
        <footer>
            <div className="footer-wrapper">
                <a href="https://www.nssl.noaa.gov">NSSL Home</a>
                <a href="https://www.nssl.noaa.gov/privacy.php">Privacy Policy</a>
                <a href="https://www.nssl.noaa.gov/disclaimers.php">Disclaimers</a>
                <a href="https://www.nssl.noaa.gov/contact.php">Contact Us</a>
            </div>
        </footer>
    );
}

export default Footer;